// import { CommonModule } from '@angular/common';
// import { HttpClient, HttpClientModule } from '@angular/common/http';
// import { Component, OnInit } from '@angular/core';
// import { RouterLink } from '@angular/router';

// @Component({
//   selector: 'app-blog',
//   standalone: true,
//   imports: [
//     CommonModule,
//     RouterLink,
//     HttpClientModule
//   ],
//   templateUrl: './blog.html',
//   styleUrl: './blog.css',
// })
// export class Blog implements OnInit {

//   blogs: any[] = [];

//   imageBaseUrl = 'https://crm-api.redmonkwellness.com';

//   apiUrl = 'https://crm-api.redmonkwellness.com/Navigation/GetPublishedBlogs';

//   constructor(private http: HttpClient) {}

//   ngOnInit(): void {
//     this.loadBlogs();
//   }

//   loadBlogs(): void {
//     this.http.get<any>(this.apiUrl).subscribe({
//       next: (res) => {
//         if (res.success) {
//           this.blogs = res.data || [];
//         }
//       },
//       error: (err) => {
//         console.error('Error loading blogs:', err);
//       }
//     });
//   }

//   generateSlug(title: string): string {
//     if (!title) return '';

//     return title
//       .toLowerCase()
//       .trim()
//       .replace(/\s+/g, '-')
//       .replace(/[^\w-]+/g, '')
//       .replace(/--+/g, '-')
//       .replace(/^-+/, '')
//       .replace(/-+$/, '');
//   }

//   setDefaultImage(event: Event): void {
//     const element = event.target as HTMLImageElement;
//     element.src = 'assets/images/blog/no-image.jpg';
//   }

// }



import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterLink } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [CommonModule, RouterLink, HttpClientModule],
  templateUrl: './blog.html',
  styleUrl: './blog.css',
})
export class Blog implements OnInit {

  blogs: any[] = [];

  imageBaseUrl = 'https://crm-api.redmonkwellness.com/';
  //imageBaseUrl = 'https://crm-api.redmonkwellness.com';

  apiUrl = 'https://crm-api.redmonkwellness.com/Navigation/GetPublishedBlogs';
  // apiUrl = 'https://crm-api.redmonkwellness.com/Navigation/GetPublishedBlogs';

  constructor(
    private http: HttpClient,
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private document: Document,

  ) {}
  
  

  ngOnInit(): void {
    this.setSeo()
    this.loadBlogs();

  }

  loadBlogs(): void {

    this.http.get<any>(this.apiUrl).subscribe({
      next: (res) => {

        if (res.success) {
          this.blogs = res.data || [];
        }

      },
      error: (err) => {
        console.error(err);
      }
    });

  }

  generateSlug(title: string): string {

    if (!title) return '';

    return title
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');

  }
  setDefaultImage(event: Event): void {
  const element = event.target as HTMLImageElement;
  element.src = '/assets/images/blog/no-image.jpg';
}





private setSeo(): void {

  // =========================
  // SEO DATA
  // =========================

  const pageTitle =
    'Red Monk Wellness Blog | Skin, Hair, Aesthetic & Wellness';

  const description =
    'Explore the Red Monk Wellness blog for insights on skin, hair, aesthetic treatments, IV therapy, wellness and beauty care.';

  const canonicalUrl =
    'https://www.redmonkwellness.com/blog';

  const ogImage =
    'https://www.redmonkwellness.com/assets/images/services/houseof-hydration-thumb.png';

  // =========================
  // TITLE
  // =========================

  this.title.setTitle(pageTitle);

  // =========================
  // BASIC META
  // =========================

  this.meta.updateTag({
    name: 'description',
    content: description
  });

  this.meta.updateTag({
    name: 'robots',
    content:
      'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
  });

  this.meta.updateTag({
    name: 'google-site-verification',
    content: '7QzARYHwPFlrxb_DWbe2CdSeHLHRU-oTXeKHpi89MXg'
  });

  // =========================
  // OPEN GRAPH
  // =========================

  this.meta.updateTag({
    property: 'og:title',
    content: pageTitle
  });

  this.meta.updateTag({
    property: 'og:description',
    content: description
  });

  this.meta.updateTag({
    property: 'og:image',
    content: ogImage
  });

  this.meta.updateTag({
    property: 'og:image:alt',
    content: 'Red Monk Wellness Blog'
  });

  this.meta.updateTag({
    property: 'og:image:type',
    content: 'image/png'
  });

  this.meta.updateTag({
    property: 'og:url',
    content: canonicalUrl
  });

  this.meta.updateTag({
    property: 'og:type',
    content: 'website'
  });

  this.meta.updateTag({
    property: 'og:locale',
    content: 'en_IN'
  });

  this.meta.updateTag({
    property: 'og:site_name',
    content: 'Red Monk Wellness'
  });

  // =========================
  // TWITTER / X
  // =========================

  this.meta.updateTag({
    name: 'twitter:card',
    content: 'summary_large_image'
  });

  this.meta.updateTag({
    name: 'twitter:title',
    content: pageTitle
  });

  this.meta.updateTag({
    name: 'twitter:description',
    content: description
  });

  this.meta.updateTag({
    name: 'twitter:image',
    content: ogImage
  });

  this.meta.updateTag({
    name: 'twitter:image:alt',
    content: 'Red Monk Wellness Blog'
  });

  // =========================
  // CANONICAL URL
  // =========================

  let canonical = this.document.querySelector(
    'link[rel="canonical"]'
  ) as HTMLLinkElement | null;

  if (!canonical) {
    canonical = this.document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    this.document.head.appendChild(canonical);
  }

  canonical.setAttribute('href', canonicalUrl);

  // =========================
  // SITEMAP
  // =========================

  let sitemap = this.document.querySelector(
    'link[rel="sitemap"]'
  ) as HTMLLinkElement | null;

  if (!sitemap) {
    sitemap = this.document.createElement('link');
    sitemap.setAttribute('rel', 'sitemap');
    sitemap.setAttribute('type', 'application/xml');
    sitemap.setAttribute('title', 'Sitemap');
    this.document.head.appendChild(sitemap);
  }

  sitemap.setAttribute(
    'href',
    'https://www.redmonkwellness.com/sitemap.xml'
  );

  // =========================
  // ORGANIZATION SCHEMA
  // =========================

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://www.redmonkwellness.com/#organization',
    name: 'Red Monk Wellness',
    url: 'https://www.redmonkwellness.com/',
    logo:
      'https://www.redmonkwellness.com/assets/images/Redmonk-Wellness-Logo-w.png',
    description:
      'Red Monk Wellness offers skin, hair, aesthetic and wellness treatments through its clinics in Mumbai and Kolkata.',
    sameAs: [
      'https://www.linkedin.com/company/red-monk-wellness',
      'https://www.facebook.com/redmonkwellness'
    ]
  };

  // =========================
  // BLOG SCHEMA
  // =========================

  const blogSchema = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    '@id': `${canonicalUrl}#blog`,
    url: canonicalUrl,
    name: 'Red Monk Wellness Blog',
    description:
      'Insights on skin, hair, aesthetic treatments, IV therapy, wellness and beauty care from Red Monk Wellness.',
    publisher: {
      '@id': 'https://www.redmonkwellness.com/#organization'
    },
    inLanguage: 'en-IN'
  };

  // =========================
  // BREADCRUMB SCHEMA
  // =========================

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${canonicalUrl}#breadcrumb`,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.redmonkwellness.com/home'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Blog',
        item: canonicalUrl
      }
    ]
  };

  // =========================
  // ADD / UPDATE JSON-LD SCHEMAS
  // =========================

  const schemas = [
    {
      id: 'organization-schema',
      data: organizationSchema
    },
    {
      id: 'blog-schema',
      data: blogSchema
    },
    {
      id: 'breadcrumb-schema',
      data: breadcrumbSchema
    }
  ];

  schemas.forEach(({ id, data }) => {
    let script = this.document.getElementById(
      id
    ) as HTMLScriptElement | null;

    if (!script) {
      script = this.document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      this.document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(data);
  });
}



}